import { render, staticRenderFns } from "./InventoryBasic.vue?vue&type=template&id=af67c21a&scoped=true"
import script from "./InventoryBasic.vue?vue&type=script&lang=js"
export * from "./InventoryBasic.vue?vue&type=script&lang=js"
import style0 from "./InventoryBasic.vue?vue&type=style&index=0&id=af67c21a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af67c21a",
  null
  
)

export default component.exports